module.exports = __webpack_public_path__ + "media/lee_pissed_on_chicken.d75ad237.mp3";